import { viewServerFile } from "../../../../../legacyComponents/util/helperFunctions"

export default async function getDocument(document, filename) {
	console.log("Getting document: ", document, filename)
	try {
		const url = document.links?.serve?.url
		await viewServerFile({ url, filename, download: true })
	} catch (error) {
		console.error(error)
	}
}
